import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import {Label} from '../ui/label';
import {User} from 'lucide-react';

const DoctorSelectionSection = ({formData, setFormData, doctors}) => {
  return (
    <Card className="glass-effect border-gray-700">
      <CardHeader>
        <CardTitle className="text-white flex items-center">
          <User className="h-5 w-5 mr-2 text-blue-400" />
          Doctor Selection
        </CardTitle>
        <CardDescription className="text-gray-300">
          Choose your preferred doctor for this consultation
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <Label htmlFor="doctor_id" className="text-white">
            Preferred Doctor
          </Label>
          <Select
            value={formData.doctor_id}
            onValueChange={value =>
              setFormData ({...formData, doctor_id: value})}
          >
            <SelectTrigger className="bg-gray-800 border-gray-600 text-white">
              <SelectValue placeholder="Select a doctor" />
            </SelectTrigger>
            <SelectContent>
              {doctors.map (doctor => (
                <SelectItem key={doctor.id} value={doctor.id}>
                  {doctor.name} - {doctor.specialization}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};

export default DoctorSelectionSection;
